import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { useDocumentFieldColor } from 'Hooks/DocumentFields';
import { Signer } from 'Interfaces/Document';
import { DocumentField, DocumentFieldTypes } from 'Interfaces/DocumentFields';
import { selectDocumentSigner } from 'Utils/selectors';

interface DocumentFieldPreviewItemProps {
  field: DocumentField;
  scale?: number;
}

const DocumentFieldPreviewItem = ({
  field,
  scale = 1,
}: DocumentFieldPreviewItemProps) => {
  const signer = useSelector(state =>
    selectDocumentSigner(state, {
      documentId: field.documentId,
      signerId: field.signerId,
    }),
  ) as Signer;

  const fieldColor = useDocumentFieldColor(signer);

  return (
    <div
      key={field.id}
      className={classNames('interactModal__documentNavigation-field', {
        'interactModal__documentNavigation-field--name':
          field.type === DocumentFieldTypes.Name,
        'interactModal__documentNavigation-field--signature':
          field.type === DocumentFieldTypes.Signature,
        'interactModal__documentNavigation-field--initial':
          field.type === DocumentFieldTypes.Initials,
        'interactModal__documentNavigation-field--date':
          field.type === DocumentFieldTypes.Date,
        'interactModal__documentNavigation-field--text':
          field.type === DocumentFieldTypes.Text,
        'interactModal__documentNavigation-field--checkbox':
          field.type === DocumentFieldTypes.Checkbox,
        [`fieldColor__${fieldColor} fieldColor__${fieldColor}--preview`]: !!fieldColor,
      })}
      style={{
        top: field.coordinateY * scale,
        left: field.coordinateX * scale,
        width: (field.width || 0) * scale,
        height: (field.height || 0) * scale,
      }}
    />
  );
};

export default DocumentFieldPreviewItem;
